import { render, staticRenderFns } from "./testAccount-dialog.vue?vue&type=template&id=bed2800a&scoped=true"
import script from "./testAccount-dialog.vue?vue&type=script&lang=js"
export * from "./testAccount-dialog.vue?vue&type=script&lang=js"
import style0 from "./testAccount-dialog.vue?vue&type=style&index=0&id=bed2800a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed2800a",
  null
  
)

export default component.exports